import { render } from "./CompanyIndex.vue?vue&type=template&id=7fc442a6"
import script from "./CompanyIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/company/components/CompanyIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7fc442a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7fc442a6', __exports__)) {
    api.reload('7fc442a6', __exports__)
  }
  
  module.hot.accept("./CompanyIndex.vue?vue&type=template&id=7fc442a6", () => {
    api.rerender('7fc442a6', render)
  })

}


export default __exports__